export default { sha: '22ec4813dd386c952e1c7d8635239e8b48a143ea', buildNumber: 'undefined' }
